<div class="dropdown">
  <span class="dd-title-test" *ngIf="label != ''" (click)="dropdownClick()" [class.red-text]="shouldBeRed()" [class.align-left]="alignLeft">{{label}}</span>
  <div *ngIf="title != ''" class="dd-small-title">{{title}}</div>
  <span class="selected-item" [style.max-width]="selectedItemWidth" (click)="dropdownClick()">{{getItemString(selectedItem)}}</span>
  <span class="selected-item" (click)="dropdownClick()"><img alt="" class="small-triangle" [src]="getDownTriangleSrc()"></span>
  <div #dropdownContent class="dropdown-content" [class.right]="getRight()">

    <div class="menu-item" [class.bold]="getItemString(item) == getItemString(selectedItem)" *ngFor="let item of items" (click)="select(item)">
      {{getItemString(item)}} <img *ngIf="getItemString(item) == getItemString(selectedItem)" class="menu-item-check" src="./assets/images/blue_check_icon_2.png">
    </div>

  </div>
</div>
